import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import css from './Notifier.module.scss';
import InfoIcon from './img/info.component.svg';

export interface INotifier {
    text: ReactNode;
    backgroundColor?: string;
    textColor?: string;
    className?: string;
}

export const Notifier: FC<INotifier> = ({
    text,
    backgroundColor = '',
    textColor = '',
    className = '',
}: INotifier) => {
    const rootClasses = classNames(css.notifierWrapper, className);

    return (
        <div className={rootClasses} style={{ backgroundColor }}>
            <InfoIcon className={css.infoIcon} />
            <div
                className={`body-xs-medium ${css.notifierText}`}
                style={{ color: textColor }}
            >
                {text}
            </div>
        </div>
    );
};

export default Notifier;
